import React, { useRef, useState } from 'react';
import { GoogleMap, MarkerF, InfoWindowF, useJsApiLoader } from '@react-google-maps/api';
import app from '../../core/constants';
import { schoolTypeOptions } from '../../core/utils/helpers';

const containerStyle = {
    width: '100%',
    height: '600px',
};

interface Props {
    lat: number | string | undefined;
    lng: number | string | undefined;
    name: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    type?: string | undefined;
}

const SchoolMap: React.FC<Props> = ({ lat, lng, name, address = '', phone = '', type = '' }) => {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: app?.GOOGLE_MAPS_API_KEY || '',
    });

    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const parsedLat = parseFloat(typeof lat === 'string' ? lat : String(lat));
    const parsedLng = parseFloat(typeof lng === 'string' ? lng : String(lng));

    const [showInfo, setShowInfo] = useState(false); // arba false jei nori tik ant click

    const typeLabel = schoolTypeOptions.find((opt) => opt.value === type)?.label || type;
    const typeColor = schoolTypeOptions.find((opt) => opt.value === type)?.color || '#fdab01';

    if (!isLoaded) return <div>Įkeliama žemėlapis...</div>;

    // Create custom marker icon based on school type color
    const markerIcon = {
        url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
            <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="16" r="12" fill="${typeColor}" stroke="#fff" stroke-width="2"/>
                <circle cx="16" cy="16" r="6" fill="#fff"/>
            </svg>
        `)}`,
        scaledSize: new window.google.maps.Size(32, 32),
    };

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={{ lat: parsedLat, lng: parsedLng }}
            zoom={17}>
            <MarkerF
                position={{ lat: parsedLat, lng: parsedLng }}
                onClick={() => setShowInfo(true)}
                onMouseOver={() => {
                    setShowInfo(true);
                }}
                icon={markerIcon} />
            {showInfo && (
                <InfoWindowF
                    position={{ lat: parsedLat, lng: parsedLng }}
                    onCloseClick={() => setShowInfo(false)}
                    options={{
                        pixelOffset: new window.google.maps.Size(0, -50), // pakeliam virš markerio
                    }}>
                    <div style={{ maxWidth: 250 }}>
                        <h4 style={{ marginBottom: 5 }}>{name || 'Mokykla'}</h4>
                        {typeLabel && <p style={{ margin: 0 }}><strong>Tipas:</strong> {typeLabel}</p>}
                        {address && <p style={{ margin: 0 }}><strong>Adresas:</strong> {address}</p>}
                        {phone && <p style={{ margin: 0 }}><strong>Telefonas:</strong> {phone}</p>}
                    </div>
                </InfoWindowF>
            )}
        </GoogleMap>
    );
};

SchoolMap.defaultProps = {
    address: '',
    phone: '',
    type: '',
};

export default SchoolMap;
